<button *ngIf="!isConfirmMode" type="button" class="btn btn-sm btn-secondary mb-1 me-4" (click)="isConfirmMode = true">
  {{ buttonLabelReturnStudy | localize }}<i class="fa fa-chevron-right mx-1"></i>
</button>

<button *ngIf="isConfirmMode" type="button" class="btn btn-sm btn-secondary me-4" (click)="onConfirm()">
  {{ buttonLabelConfirm | localize }}
</button>
